/**
 * This javascript file will automatically include all translation modules
 * and exports the resulting object
 *
 * Webpack compiles its bundles ahead of time, so it's unfortunately
 * not possible to use variables/functions in the require.context(arguments),
 * as it would only run and evaluate the variable after the build step.
 *
 * Don't forget to also add locale option in @/components/LocaleSwitch.vue
 */

import importTranslations from '@/functions/importTranslations';
import dateTimeFormats from './formats/datetime/en.json';
import en from 'vuetify/lib/locale/en';

const messages = importTranslations(
  require.context('./lang', true, /en\.ya?ml$/)
);

messages.$vuetify = en;

export { messages, dateTimeFormats };
